import moment from "moment";
import { useHistory } from "react-router-dom";
import { addDays } from "date-fns";
const { createSlice } = require("@reduxjs/toolkit");

export const initialState = {
  timeSeries: {
    start: moment(addDays(new Date(), -7)).format("DD-MM-YYYY"),
    end: moment(new Date()).format("DD-MM-YYYY"),
  },
};

const dashboardSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    setTimeSeries: (state, { payload }) => {
      state.timeSeries = payload;
    },
  },
});

export const { setTimeSeries } = dashboardSlice.actions;

export default dashboardSlice.reducer;
